module.exports = "/static/js/ef32ea2bdf63ba132b4ced047203650d.png";